module.exports = __webpack_public_path__ + "static/img/团队成员-曹东兴.fa06e5c3.jpg";